// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // Import Firestore

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCRuKYW0Vfc6vh2VS8Z8Qy_j7WGuVUFYB8",
  authDomain: "sixsphere-dd766.firebaseapp.com",
  projectId: "sixsphere-dd766",
  storageBucket: "sixsphere-dd766.appspot.com",
  messagingSenderId: "310171660840",
  appId: "1:310171660840:web:1dd10d6c1cd0b80d9dfb1d",
  measurementId: "G-RS75PP970F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app); // Initialize Firestore

export { auth, googleProvider, db };